import React, { Component } from "react";
import { connect } from "react-redux";
import { showModal } from "../../redux/actions/modalActions";
import { updatePriceAlert } from "../../redux/actions/priceAlertActions";
import PriceAlertStatus from "./PriceAlertStatus";
import DeletePriceAlertModalContentMobile from "./priceAlertOptions/DeletePriceAlertModalContentMobile";
import UnlockPremiumModal from "../popups/UnlockPremiumModal";

interface Props {
  priceAlert: PriceAlert;
  updatePriceAlert: any;
  showModal: any;
  user?: UserState;
}

interface State {
  newAlertPrice: number;
}

class PriceAlertCardMobile extends Component<Props, State> {
  state = {
    newAlertPrice: this.props.priceAlert.alert_price,
  };

  showDeletePriceAlert = () => {
    const itemCard = document.getElementById(
      this.props.priceAlert.item.id.toString()
    );
    if (itemCard) {
      const modalContent = () => (
          <div className="u-overflow-hidden">
            {this.props.user?.isPremium && (
                <DeletePriceAlertModalContentMobile
                    priceAlert={this.props.priceAlert}
                />
            )}

            {!this.props.user?.isPremium && <UnlockPremiumModal />}
          </div>
      );
      this.props.showModal({
        position: "bottom",
        component: modalContent,
      });
    }
  };

  searchKeyStrokeChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    // Allow empty field temporarily during editing
    const value = e.currentTarget.value;
    if (value === '') {
      this.setState({ newAlertPrice: '' as any });
    } else {
      // Convert to number if valid
      const numValue = parseFloat(value);
      if (!isNaN(numValue)) {
        this.setState({ newAlertPrice: numValue });
      }
    }
  };

  onKeyPress = (e: React.KeyboardEvent<HTMLInputElement>) => {
    const characterCode = e.charCode || e.keyCode || e.key;
    // if user presses enter
    if (characterCode === 13) {
      // Validate before sending to ensure we have a valid number
      if (typeof this.state.newAlertPrice === 'string' && this.state.newAlertPrice === '') {
        // Default to 0 if empty
        this.setState({ newAlertPrice: 0 }, () => {
          this.props.updatePriceAlert(
            this.props.priceAlert.item.id,
            this.state.newAlertPrice
          );
        });
      } else {
        this.props.updatePriceAlert(
          this.props.priceAlert.item.id,
          this.state.newAlertPrice
        );
      }
    }
  };

  // Find all vendors with prices below or equal to the alert price
  findAllMatchingVendors = (itemPricing: any[], alertPrice: number) => {
    if (!itemPricing || !itemPricing.length) return { matchedVendors: [] };
    
    // Find all vendors that have a price at or below the alert price
    const matchedVendors = itemPricing
      .filter(pricing => pricing.price <= alertPrice)
      .map(pricing => ({
        vendorId: pricing.vendor_id,
        vendor: pricing.vendor_id === 1 ? "Coles" : "Woolworths",
        price: pricing.price
      }));
    
    return { matchedVendors };
  };
  
  render() {
    const priceAlert = this.props.priceAlert;
    
    // Handle is_triggered property safely with type assertion to avoid TypeScript errors
    const is_triggered = (priceAlert as any)?.is_triggered || false;
    
    // Get all vendors with prices below or equal to the alert price
    let matchedVendors = [];
    if (is_triggered && priceAlert?.item?.item_pricing) {
      matchedVendors = this.findAllMatchingVendors(
        priceAlert.item.item_pricing,
        priceAlert.alert_price
      ).matchedVendors;
    }
    
    return (
      <div className="u-background--white u-border--bottom--darkgrey">
        {/* Price Alert Status positioned at the top with proper spacing */}
        <div className="u-pt--12 u-pl--12">
          <PriceAlertStatus 
            priceAlert={priceAlert} 
            label="Active" 
            isMobile={true}
            matchedVendors={matchedVendors}
          />
        </div>
        <div className="u-flex u-flex-column u-ph--12">
          <div className="u-w-all u-flex u-align-center">
            <div className="u-w-25pct u-pl--12--mobile">
              <img
                style={{ height: "80px" }}
                alt={priceAlert.item.name}
                src={priceAlert.item.image_url}
              />
            </div>
            <div
              className="u-pl--32 u-color-charcoal u-semi-bold"
              style={{ fontSize: 14 }}
            >
              <div>{priceAlert.item.name}</div>
            </div>
          </div>
          <div className="u-w-all u-flex u-align-center u-pv--12">
            <div className="u-flex u-text-center u-ph--12" style={{ flex: 1 }}>
              <button
                className="u-color-magenta u-w-all u-semi-bold "
                style={{ fontSize: 14 }}
                onClick={this.showDeletePriceAlert}
              >
                Delete
              </button>
            </div>
            <div className="u-pl--20 u-w-all" style={{ flex: 4 }}>
              <div className="u-w-all u-flex u-justify-between u-align-center u-ph--16 u-pv--12" 
                style={{
                  backgroundColor: '#f5f5f5', 
                  borderRadius: '6px',
                  border: '1px solid #e0e0e0',
                  position: 'relative',
                  cursor: 'pointer',
                  transition: 'all 0.2s ease',
                  boxShadow: '0 1px 2px rgba(0,0,0,0.05)'
                }}
                title="Click to edit alert price"
                onClick={() => {
                  const inputElement = document.getElementById('alertPriceInputMobile-' + priceAlert.item.id);
                  if (inputElement) {
                    (inputElement as HTMLInputElement).focus();
                  }
                }}>
                <div className="u-pr--12 u-semi-bold" style={{ fontSize: 14, color: '#666' }}>
                  When price at
                </div>
                <div className="u-flex u-flex-column" style={{ position: 'relative' }}>
                <div className="u-background--white u-ph--4 u-bold u-flex u-align-center" style={{ position: 'relative' }}>
                  <div className="u-pv--16 u-color-darkgrey">$</div>
                  <input
                    id={`alertPriceInputMobile-${priceAlert.item.id}`}
                    className="u-pv--16 u-bold u-ph--8"
                    style={{ 
                      width: "75px", 
                      borderBottom: '1px dashed transparent',
                      transition: 'all 0.2s ease',
                      outline: 'none'
                    }}
                    value={
                      typeof this.state.newAlertPrice === "string"
                        ? this.state.newAlertPrice
                        : this.state.newAlertPrice.toFixed(2)
                    }
                    type="text"
                    inputMode="decimal"
                    onChange={(e) => this.searchKeyStrokeChange(e)}
                    onMouseOver={(e) => {
                      e.currentTarget.style.borderBottom = '1px dashed #9300DA';
                      e.currentTarget.style.color = '#9300DA';
                    }}
                    onMouseOut={(e) => {
                      e.currentTarget.style.borderBottom = '1px dashed transparent';
                      e.currentTarget.style.color = '#333';
                    }}
                    onFocus={(e) => {
                      e.currentTarget.style.borderBottom = '1px dashed #9300DA';
                      e.currentTarget.style.color = '#9300DA';
                    }}
                    onBlur={(e) => {
                      e.currentTarget.style.borderBottom = '1px dashed transparent';
                      e.currentTarget.style.color = '#333';
                      this.props.updatePriceAlert(
                        priceAlert.item.id,
                        this.state.newAlertPrice
                      );
                    }}
                    onKeyDown={(e) => this.onKeyPress(e)}
                  />

                </div>
                {/* {priceInfo && priceInfo.price && (
                  <div className="u-mt--8 u-mb--8">
                    <div className="u-border--1 u-color-red u-background--light-pink u-ph--8 u-pv--4 u-main-font--vsmall" style={{ borderColor: '#FF6B6B', fontSize: '12px' }}>
                      Now {priceInfo.vendorId === 1 ? (
                        <>
                          <span className="u-background--white u-color-woolworths u-pv--2 u-ph--4 u-bold u-br--small">W</span>
                          {' '}
                        </>
                      ) : (
                        <>
                          <span className="u-background--white u-color-coles u-pv--2 u-ph--4 u-bold u-br--small">C</span>
                          {' '}
                        </>
                      )}
                      ${priceInfo.price.toFixed(2)}
                    </div>
                  </div>
                )} */}
              </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

const mapToStateProps = (state: ReduxState) => ({
  user: state.user,
});
export default connect(mapToStateProps, { updatePriceAlert, showModal })(
  PriceAlertCardMobile
);
